/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindSellerPublicProductsQueryResponse,
  TelegramProductsControllerFindSellerPublicProductsPathParams,
  TelegramProductsControllerFindSellerPublicProductsQueryParams,
  TelegramProductsControllerFindSellerPublicProducts401,
} from '../../types/TelegramProductsControllerFindSellerPublicProducts.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindSellerPublicProducts } from '../../methods/telegramProductsFindSellerPublicProducts.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindSellerPublicProductsQueryKey = (
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProductsPathParams['sellerPublicProfileId'],
  params: TelegramProductsControllerFindSellerPublicProductsQueryParams,
) =>
  [
    {
      url: '/api/telegram/products/seller/:sellerPublicProfileId/products',
      params: { sellerPublicProfileId: sellerPublicProfileId },
    },
    ...(params ? [params] : []),
  ] as const;

export type TelegramProductsFindSellerPublicProductsQueryKey = ReturnType<
  typeof telegramProductsFindSellerPublicProductsQueryKey
>;

export function telegramProductsFindSellerPublicProductsQueryOptions(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProductsPathParams['sellerPublicProfileId'],
  params: TelegramProductsControllerFindSellerPublicProductsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindSellerPublicProductsQueryKey(sellerPublicProfileId, params);
  return queryOptions<
    TelegramProductsControllerFindSellerPublicProductsQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProducts401>,
    TelegramProductsControllerFindSellerPublicProductsQueryResponse,
    typeof queryKey
  >({
    enabled: !!(sellerPublicProfileId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindSellerPublicProducts(sellerPublicProfileId, params, config);
    },
  });
}

/**
 * {@link /api/telegram/products/seller/:sellerPublicProfileId/products}
 */
export function useTelegramProductsFindSellerPublicProducts<
  TData = TelegramProductsControllerFindSellerPublicProductsQueryResponse,
  TQueryData = TelegramProductsControllerFindSellerPublicProductsQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindSellerPublicProductsQueryKey,
>(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProductsPathParams['sellerPublicProfileId'],
  params: TelegramProductsControllerFindSellerPublicProductsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindSellerPublicProductsQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProducts401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? telegramProductsFindSellerPublicProductsQueryKey(sellerPublicProfileId, params);

  const query = useQuery(
    {
      ...telegramProductsFindSellerPublicProductsQueryOptions(sellerPublicProfileId, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProducts401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
